import { nanoid } from "nanoid";

import { idb } from "../../idb.js";

export const addIncomingMessage = async ({ caseID, message, type }) => {
  const { id, timestamp } = message?.message || {};

  const connection = await idb();

  await connection.add("incomingMessages", {
    caseID,
    createdAt: new Date(),
    dismissed: false,
    id: id || nanoid(),
    raw: message,
    silenced: false,
    timestamp: timestamp || 0,
    type,
  });

  return id;
};
